import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-collapse@1.10.1@rc-collapse/es/index.js
// module id = 278
// module chunks = 0 1